<template>
<div>
    <sav-template :title="'Connexion'">
        <div v-if="$route.query.next" class="p-4 mb-3 font-normal bg-orange-100 border border-orange-200 my-rounded">
            <i class="mr-1 fa-solid fa-triangle-exclamation"></i> {{$t('connexion.vous_devez_etre_authentifie_pour_continuer_la_procedure')}}
        </div>
        <div class="p-6 bg-white shadow border my-rounded text-center sm:max-w-[400px] mx-auto">
            <div class="text-left border-b mb-5 pb-5">
                <div class="font-bold text-xl">{{$tt("Accéder à votre espace")}}</div>
                <div class="font-light text-sm">{{$tt("En vous connectant sur votre compte")}}</div>
            </div>

            <div v-if="errors && errors.length > 0" class="bg-red-500 text-white p-4 rounded-lg mb-6 text-left">
                <div class="font-bold border-b mb-2 pb-2">{{ $tt('Erreurs') }}</div>
                <ul class="ml-4 list-disc text-sm">
                    <li v-for="(error, errorIndex) in errors" :key="'error-' + errorIndex">{{ error }}</li>
                </ul>
            </div>

            <sav-input class="mb-4" :label="$tt('Adresse email')" type="email" v-model="email" />
            <sav-input class="mb-2" :label="$tt('Mot de passe')" type="password" v-model="password" />
            <div class="mb-8">
                <button @click="$router.push({ name: 'user.password-forgot', query: {next: redirect}})" class="text-slate-500 hover:text-slate-600 hover:underline font-light text-sm cursor-pointer">Mot de passe oublié ?</button>
            </div>
            
            <button @click="submit" class="py-3 px-6 text-sm rounded-lg font-bold bg-green-500 hover:bg-green-600 duration-200 text-white">
                <template v-if="!loaderLogin">{{ $tt('Se connecter') }}</template>
                <sav-spinner v-if="loaderLogin" :size="10" />
            </button>

            <div class="flex gap-4 items-center mt-8 mb-4">
                <div class="border-b grow"></div>
                <div class="font-light text-sm">{{ $tt('Ou inscrivez-vous') }}</div>
                <div class="border-b grow"></div>
            </div>
            <button @click="$router.push({ name: ($companyTool.confFile().pro_particulier == 1 ? 'user.login.actors' : 'user.register'), query: {next: redirect}})" class="mb-4 bg-slate-100 hover:bg-slate-200 duration-200 text-sm px-4 py-2 font-light rounded-lg">
                {{ $tt('Créer un compte') }}
            </button>
        </div>
        <!-- <div class="grid grid-cols-1 gap-4 mt-4 lg:grid-cols-2">
            <router-link :to="{ name: ($companyTool.confFile().pro_particulier == 1 ? 'user.login.actors' : 'user.register'), query: {next: this.redirect}}">
                <div test-id="button-go-to-register" class="p-6 duration-200 bg-white shadow border hover:bg-gray-50 my-rounded">
                    <div class="flex items-center">
                        <img class="h-20 my-rounded" src="https://disticloudfiles.net/img/savinfo/default/register.webp" alt="">
                        <div class="ml-3">
                            <h2 class="text-xl font-bold">{{$t('connexion.vous_etes_nouveau_?')}}</h2>
                            <span class="font-light">{{$t('connexion.inscrivez_vous')}}</span>
                        </div>
                    </div>
                </div>
            </router-link>
            <router-link :to="{ name: 'user.password-forgot', query: {next: this.redirect}}">
                <div test-id="button-go-to-forget-password" class="p-6 duration-200 bg-white shadow border hover:bg-gray-50 my-rounded">
                    <div class="flex items-center">
                        <img class="h-20 my-rounded" src="https://disticloudfiles.net/img/savinfo/default/mot_de_passe_oublie.webp" alt="">
                        <div class="ml-3">
                            <h2 class="text-xl font-bold">{{$t('connexion.mot_de_passe_oublie_?')}}</h2>
                            <span class="font-light">{{$t('connexion.reinitialiser_le_mot_de_passe')}}</span>
                        </div>
                    </div>
                </div>
            </router-link>
        </div>-->
    </sav-template>
</div>
</template>

<script>
import sha256 from 'js-sha256';
import apiService from '@/services/api.service';
import SavInput from '../../../../components/SavInput.vue';
export default {
  components: { SavInput },
    data() {
        return {
            errors: [],
            redirect: '',
            email: null,
            password: null,
            loaderLogin: false,
        }
    },

    mounted() {
        this.redirect = this.$route.query.next
    },

    methods: {
        async submit() {
            this.errors = []

            // validation
            if (!this.email) {
                this.errors.push(this.$tt("L'adresse email est obligatoire"))
            }
            if (!this.password) {
                this.errors.push(this.$tt("Le mot de passe est obligatoire"))
            }
            if (this.errors && this.errors.length > 0) {
                return
            }

            // Init data
            const email = this.email
            const password = sha256(this.password)

            // Send request
            this.loaderLogin = true
            let response = await apiService.post('connexion', {
                mail: email,
                password: password
            })

            // Manage response
            if (response.data.posts.error) {
                this.errors.push(this.$tt(response.data.posts.error))
            } else if (response.data.posts.post[0].token_mob) {
                localStorage.setItem('client_id', this.$crypto.encrypt(response.data.posts.post[0].token_mob))

                if (!this.redirect) {
                    this.$router.push({name: 'home'})
                } else {
                    this.$router.push({name: this.redirect})
                }
            } else {
                this.errors.push(this.$t('connexion.erreur_lors_de_la_connexion_veuillez_essayer_a_nouveau'))
            }
            this.loaderLogin = false
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/companies/default/views/user/Login.vue